import React, { FC } from 'react'
import { useDispatch } from 'react-redux'
import { Segment, Grid } from 'semantic-ui-react'
import { date as dateFormatter, dateTime as dateTimeFormatter } from 'loankeeper-common/helpers/formatters'
import { translate } from 'loankeeper-common/helpers'
//@ts-ignore
import LKGrid from 'shared/LKGrid'
//@ts-ignore
import LKGridExportButton from 'shared/LKGrid/ExportButton'
import { colors } from 'shared'
//@ts-ignore
import { FlexTableChild, TableContainer, GridContainer, FlexContainer } from 'shared/StyledComponents'
//@ts-ignore
import LKButton from 'shared/LKButton'
import { translateCmd } from '../../helpers'
import { formName } from '../../constants'
import { openFileDetails } from '../../../FileDetails'
import { NotesGridProps } from '../../types'
import { downloadRemote } from '../../../FileDetails'
const commonConfig = {
  gridIdentity: { formName, objectName: 'dbgrd_notes' },
  // columnDefs: [
  //   { headerName: 'NDate', field: 'NDate' },
  //   { headerName: 'Comment', field: 'Comment' },
  //   { headerName: 'Title', field: 'Title' },
  //   { headerName: 'LoginFull', field: 'LoginFull' },
  //   { headerName: 'Title_ALT', field: 'Title_ALT' },
  //   { headerName: 'OpenDay', field: 'OpenDay' },
  // ],
  syncGridState: true,
  enableColumnsResize: true,
  enableColumnsOrder: true,
  enableSorting: true,
  enableRowSelection: true,
  getRowStyle: ({
    node: {
      data: { Active },
    },
  }) => {
    if (Active === 2) {
      return { backgroundColor: colors.grey }
    }
    return {}
  },
  columnConfigs: {
    OpenDay: { valueFormatter: ({ value }) => dateFormatter(value) },
    NDate: { valueFormatter: ({ value }) => dateTimeFormatter(value) },
  },
}

const dynamicConfig = ({
  onPreviewNoteModalOpen,
  onEditNoteModalOpen,
  onDeleteNoteModalOpen,
  linkedfiles,
  viewFile,
  downloadFile,
}) => ({
  getContextMenuItems: ({ node: { data } }) => {
    const foundFile = linkedfiles.find((lf) => lf.ID === data.LFLID)
    let showDownload = false

    if (foundFile) {
      showDownload = ['xlsx', 'xls', 'docx', 'doc'].includes(foundFile.Ext)
    }

    return [
      {
        name: translateCmd('preview_linkedfile'),
        action: () => onPreviewNoteModalOpen(data),
        icon: 'preview',
      },
      ...(data.LFLID && !showDownload
        ? [
            {
              name: translate('frm_loan_view-cmd_view_lfl'),
              action: () => {
                const { LFLID } = data

                if (LFLID) {
                  const { HashSum_FileID_: hash, Ext } = foundFile

                  viewFile(LFLID, hash, Ext)
                }
              },
              icon: 'preview',
            },
          ]
        : []),
      ...(foundFile && showDownload
        ? [
            {
              name: translate('frm_web_messages-cmd_lfl_download'),
              action: () => {
                const { HashSum_FileID_: hash, Ext } = foundFile
                downloadFile(data.LFLID, hash, Ext)
              },
              icon: 'download',
            },
          ]
        : []),
      {
        name: translateCmd('edit_note'),
        action: () => {
          onEditNoteModalOpen(data)
        },
        icon: 'edit',
        permissionKey: 'EDIT_CLIENT_NOTE',
      },
      {
        name: translateCmd('delete_note'),
        action: () => {
          onDeleteNoteModalOpen(data)
        },
        icon: 'delete',
        permissionKey: 'DELETE_CLIENT_NOTE',
      },
      'excelExport',
    ]
  },
})

function getConfig(args) {
  return {
    ...commonConfig,
    ...dynamicConfig(args),
  }
}

const NotesGrid: FC<NotesGridProps> = React.memo((props) => {
  const {
    notes,
    onPreviewNoteModalOpen,
    onAddNoteModalOpen,
    onEditNoteModalOpen,
    onDeleteNoteModalOpen,
    instanceName,
    linkedfiles,
  } = props

  const dispatch = useDispatch()

  return (
    <FlexContainer>
      <FlexTableChild>
        <TableContainer>
          <LKGrid
            rowData={notes}
            {...getConfig({
              onEditNoteModalOpen,
              onDeleteNoteModalOpen,
              onPreviewNoteModalOpen,
              linkedfiles,
              viewFile: (ID: number, hash: string, type: number) => {
                dispatch(openFileDetails({ ID, hash, type }))
              },
              downloadFile: (ID: number, hash: string, extension: string) => {
                dispatch(downloadRemote({ ID, hash, extension }))
              },
            })}
            instanceName={instanceName}
          />
        </TableContainer>
      </FlexTableChild>

      <Segment>
        <GridContainer>
          <Grid>
            <Grid.Row columns={1}>
              <Grid.Column>
                <LKButton alias="add" size="tiny" onClick={onAddNoteModalOpen} permission="ADD_CLIENT_NOTE">
                  {translateCmd('add_note')}
                </LKButton>

                <LKGridExportButton alias="export" size="tiny" instanceName={instanceName} />
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </GridContainer>
      </Segment>
    </FlexContainer>
  )
})

export default NotesGrid
